import { defineMessages } from 'react-intl';
import cloneDeep from 'lodash/cloneDeep';

const messages = defineMessages({
  title: {
    id: 'CSJ card',
    defaultMessage: 'Targeta CSJ',
  },
  image: {
    id: 'CSJ card image',
    defaultMessage: 'Imatge',
  },
  itemTitle: {
    id: 'CSJ card title',
    defaultMessage: 'Títol',
  },
  link: {
    id: 'CSJ card link',
    defaultMessage: 'Enllaç',
  },
  description: {
    id: 'CSJ card description',
    defaultMessage: 'Descripció',
  },
  descriptionExtra: {
    id: 'CSJ card description extra',
    defaultMessage: 'Descripció addicional',
  },
});

export const CardSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['image', 'title', 'link', 'description', 'description_extra'],
    },
  ],
  properties: {
    image: {
      title: intl.formatMessage(messages.image),
      widget: 'object_browser',
      mode: 'image',
      return: 'single',
      selectableTypes: ['Image'],
      initialPath: '/recursos',
      selectedItemAttrs: ['@type', 'title', 'image_field', 'image_scales'],
    },
    title: {
      title: intl.formatMessage(messages.itemTitle),
      widget: 'text',
    },
    link: {
      title: intl.formatMessage(messages.link),
      widget: 'text',
    },
    description: {
      title: intl.formatMessage(messages.description),
      widget: 'textarea',
    },
    description_extra: {
      title: intl.formatMessage(messages.descriptionExtra),
      widget: 'textarea',
    },
  },
  required: ['image', 'description'],
});

export const resolveCardVariation = (formData) =>
  formData?.variation || formData?.variant || 'photo';

export const getCardSchemaForData = ({ intl, formData }) => {
  const schema = CardSchema({ intl });
  const variant = resolveCardVariation(formData);

  if (variant === 'label-top') {
    const mutated = cloneDeep(schema);
    mutated.fieldsets[0].fields = ['image', 'title', 'link'];
    mutated.required = ['image', 'title'];
    return mutated;
  }

  if (variant === 'stacked') {
    const mutated = cloneDeep(schema);
    mutated.required = ['image', 'description'];
    return mutated;
  }

  if (variant === 'icon') {
    const mutated = cloneDeep(schema);
    mutated.required = ['image', 'title', 'description'];
    return mutated;
  }

  return schema;
};

export const cardSchemaEnhancer = ({ schema, formData, intl }) =>
  getCardSchemaForData({ intl, formData });
